import { LocationAllocation } from '@/types/stockDispatch';
import { Item } from '@/types/types';

export const allocatedQuantity = (deliveries: LocationAllocation[], itemId: string): number =>
    deliveries.reduce((total, unit) => total + (unit.items[itemId] || 0), 0);

/** Retorna uma nova distribuição somente se o saldo de todos os locais permitir. */
export function allocateMaterial(deliveries: LocationAllocation[], unit: LocationAllocation, item: Item, quantity: number): LocationAllocation[] {
    if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error('Informe uma quantidade inteira válida.');
    const previous = deliveries.find(d => d.localId === unit.localId)?.items[item.id] || 0;
    const total = allocatedQuantity(deliveries, item.id) - previous + quantity;
    if (total > item.quantity && quantity > previous) throw new Error('A quantidade ultrapassa o saldo disponível para esta saída.');
    if (!item.consumable && total > 1) throw new Error('Este material é individualizado e só pode ser enviado uma vez.');
    const next = { ...unit, items: { ...unit.items } };
    if (quantity === 0) delete next.items[item.id];
    else next.items[item.id] = quantity;
    return deliveries.some(d => d.localId === unit.localId)
        ? deliveries.map(d => d.localId === unit.localId ? next : d)
        : [...deliveries, next];
}

export function materialLabel(item: Item): string {
    const values = [item.itemType?.name, item.brand?.name, item.model?.name,
        ...(item.specifications || []).map(s => `${s.key?.displayName || s.key?.keyName || ''}: ${s.value}`),
        item.serialNumber ? `Série: ${item.serialNumber}` : '', item.patrimony ? `Patrimônio: ${item.patrimony}` : '', !item.consumable && !item.serialNumber && !item.patrimony ? `Registro: ${item.id.slice(0,8)}` : ''];
    return values.filter(Boolean).join(' - ');
}
